import { ButtonBase, Stack, styled, Typography } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const ButtonContainer = styled(ButtonBase)(({ theme }) => ({
  border: `1px solid ${NEW_COLORS.GRAYSCALE[200]}`,
  color: NEW_COLORS.SECONDARY[200],
  flexDirection: 'row',
  alignItems: 'center',
  borderRadius: '8px',
  cursor: 'pointer',
  padding: '24px',
  gap: '16px',
  flex: 1,
  backgroundColor: NEW_COLORS.BASE.WHITE,
  '&:hover': {
    cursor: 'pointer',
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    padding: '16px',
    maxWidth: '130px',
    backgroundColor: NEW_COLORS.BASE.WHITE,
    flex: '0 0 auto',
    scrollSnapAlign: 'start',
  },
}));

const IconContainer = styled(Stack)`
  background-color: rgba(244, 159, 0, 0.175);
  border-radius: 8px;
  padding: 8px;
`;

const StyledStack = styled(Stack)(() => ({
  gap: '24px',
  flexWrap: 'wrap',
  overflow: 'visible',
  flexDirection: 'row',
  '& > *': {
    minWidth: 'auto',
    flex: '1 1 0',
  },
}));

const QuickActionText = styled(Typography)`
  white-space: nowrap;
  @media (max-width: 768px) {
    white-space: wrap;
    text-align: center;
  }
`;

export { QuickActionText, IconContainer, ButtonContainer, StyledStack };
